import React from "react";
import {
  List,
  ListItem,
  ListItemText,
  Avatar,
  Grid,
  Typography,
  Paper,
  Box,
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import DescriptionIcon from "@mui/icons-material/Description";

function DetalleFicha({ row }) {
  const rowItems = row.equipo
    ? row.equipo.split(" -- ").map((item, index) => {
        const [cantidadDesc, fechaEntrega] = item.split(" fecha de Entrega: ");
        const [cantidad, descripcion] = cantidadDesc.split(" descripción: ");

        return (
          <Paper
            key={index}
            elevation={2}
            sx={{
              p: 2,
              mb: 2,
              backgroundColor: "#fdfefe",
              border: "1px solid #d6eaf8",
              borderRadius: 2,
            }}
          >
            <Grid container spacing={2} alignItems="center" flexWrap="wrap">
              <Grid item xs={12} sm={4} display="flex" alignItems="center">
                <Avatar sx={{ bgcolor: "#3498db", width: 28, height: 28, mr: 1 }}>
                  <ShoppingBagIcon fontSize="small" />
                </Avatar>
                <Box>
                  <Typography variant="caption" color="textSecondary">
                    Artículo
                  </Typography>
                  <Typography variant="body2" fontWeight="bold">
                    {cantidad}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} sm={5} display="flex" alignItems="center">
                <Avatar sx={{ bgcolor: "#3498db", width: 28, height: 28, mr: 1 }}>
                  <DescriptionIcon fontSize="small" />
                </Avatar>
                <Box>
                  <Typography variant="caption" color="textSecondary">
                    Descripción
                  </Typography>
                  <Typography variant="body2" fontWeight="bold">
                    {descripcion}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} sm={3} display="flex" alignItems="center">
                <Avatar sx={{ bgcolor: "#3498db", width: 28, height: 28, mr: 1 }}>
                  <EventIcon fontSize="small" />
                </Avatar>
                <Box>
                  <Typography variant="caption" color="textSecondary">
                    Fecha de Entrega
                  </Typography>
                  <Typography variant="body2" fontWeight="bold">
                    {fechaEntrega}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        );
      })
    : null;

  return (
    <Box
      sx={{
        width: "100%",
        px: 2,
        py: 2,
        backgroundColor: "#ebf5fb",
        borderRadius: 2,
      }}
    >
      {rowItems}
    </Box>
  );
}

export default DetalleFicha;
